import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ServiceRequestCompletedSubHeaderComponent } from './service-request-completed-sub-header.component';
import { TranslateModule } from '@ngx-translate/core';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [ServiceRequestCompletedSubHeaderComponent],
  imports: [CommonModule, TranslateModule, StaticMsgModule],
  exports: [ServiceRequestCompletedSubHeaderComponent],
})
export class ServiceRequestCompletedSubHeaderModule {}
